import { render, staticRenderFns } from "./submit-btn.vue?vue&type=template&id=2d1dfbcc&scoped=true&"
import script from "./submit-btn.vue?vue&type=script&lang=js&"
export * from "./submit-btn.vue?vue&type=script&lang=js&"
import style0 from "./submit-btn.vue?vue&type=style&index=0&id=2d1dfbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1dfbcc",
  null
  
)

export default component.exports